export const APIDOC = process.env.REACT_APP_BASE_URL_DOKTER
export const API5 = process.env.REACT_APP_BASE_URL_UTAMA
export const API7 = process.env.REACT_APP_BASE_URL_UTAMA_PHP7
export const APISATSET = process.env.REACT_APP_BASE_URL_SATUSEHAT
export const APIBPJS = process.env.REACT_APP_BASE_URL_BPJS
